import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import regeneratorRuntime from "/var/jenkins_home/workspace/tingle.b3d8d2dd-4150-4941-b835-9e77a885faf1/workspace/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
// ignore-string-externalization
import { createLoader, useRead } from "@spotify-internal/creator-data-loading";
import { Logger } from "@mrkt/features/Platform";
import { webgateFetch, WEBGATE_DOMAIN } from "../../shared/lib/api";
import { withHooks } from "@mrkt/features/withHooks";
export var endpoint = "".concat(WEBGATE_DOMAIN, "/s4x-me/v0/me");
var eventName = "load-currentuser";
export var currentUserLoader = createLoader(function() {
    var _ref = // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _async_to_generator(regeneratorRuntime.mark(function _callee(_key) {
        var response, data, formatted;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return webgateFetch(endpoint);
                case 3:
                    response = _ctx.sent;
                    if (!(response.status === 401)) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 6:
                    if (response.ok) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error("".concat(response.status, " ").concat(response.url));
                case 8:
                    _ctx.next = 10;
                    return response.json();
                case 10:
                    data = _ctx.sent;
                    formatted = _object_spread({
                        email: data.loginEmail
                    }, data);
                    Logger.logSuccess(eventName);
                    return _ctx.abrupt("return", formatted);
                case 16:
                    _ctx.prev = 16;
                    _ctx.t0 = _ctx["catch"](0);
                    Logger.logError(eventName, _ctx.t0);
                    throw _ctx.t0;
                case 20:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                16
            ]
        ]);
    }));
    return function(_key) {
        return _ref.apply(this, arguments);
    };
}(), {
    cacheKeyFn: function() {
        return 0;
    }
});
export function useCurrentUser() {
    return useRead(currentUserLoader, 0);
}
export var withCurrentUser = withHooks(function() {
    return {
        currentUser: useCurrentUser()
    };
});
